<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 详情页头部 -->
      <div class="page-card__header" style="font-weight: bold;font-size: 22px;line-height: 60px;">
        展会详情
      </div>

      <!-- 展会详情内容 -->
      <div class="page-card__body">
        <div v-html="info" style="width: 800px;margin: 0 auto;padding: 20px 0"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "exhibitionDetail",
    data() {
      return {
        info:'',
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 获取展会详情数据
      getData() {
        let url = this.baseUrl + "/user/config/";
        api.fetchData(url).then((res) => {
          this.info = res[0].info;
        });
      },
    },
  }
</script>

<style scoped>
  ::v-deep img{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/exhibitionDetail.vue